import { Quill } from 'react-quill-new';

const Embed = Quill.import('blots/embed');

class LargeFormula extends Embed {
  static create(value) {
    if (window.katex == null) {
      throw new Error('Formula module requires KaTeX.');
    }
    const node = super.create(value);

    if (typeof value === 'string') {
      window.katex.render(value, node, {
        throwOnError: false,
        errorColor: '#f00',
      });
      node.setAttribute('data-value', value);
    }
    return node;
  }

  static value(domNode) {
    return domNode.getAttribute('data-value');
  }
}
LargeFormula.blotName = 'largeFormula';
LargeFormula.className = 'ql-formulaLarge';
LargeFormula.tagName = 'DIV';

export default LargeFormula;
